import messages from './tag-messages.js';
export default [
    {tag: '春节', intlLabel: messages.spring},
    {tag: '圣诞节', intlLabel: messages.christmas},
    {tag: '元旦', intlLabel: messages.new_year},
    {tag: 'animals', intlLabel: messages.animals},
    {tag: 'effects', intlLabel: messages.effects},
    {tag: 'electronic', intlLabel: messages.electronic},
    {tag: 'vocals', intlLabel: messages.vocals},
    {tag: 'instruments', intlLabel: messages.instruments},
    {tag: 'music-loops', intlLabel: messages.loops},
    {tag: 'notes', intlLabel: messages.notes},
    {tag: 'percussion', intlLabel: messages.percussion},
    {tag: 'human', intlLabel: messages.voice},
    {tag: '三国演义', intlLabel: messages.three_kingdoms},
    {tag: '教师节', intlLabel: messages.teachers_day},
    {tag: '母亲节', intlLabel: messages.mothers_day}
];
